import { createContext } from 'react';
export var I18nContext = createContext();